module.exports = __webpack_public_path__ + "img/award-1.87e2d424.svg";